import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import WarningIcon from "@material-ui/icons/WarningRounded";
import { Button } from "@packages/ui";
import { useDispatch, useSelector } from "react-redux";
import * as appActions from "../../actions/appActions";
import { useNavigate } from "react-router-dom";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import Lightbox from "react-image-lightbox";
import brandColors from "@packages/ui/theme/colors";


const SmsPage = () => {
  const classes = useStyles();
  const [damageCodes, setDamageCodes] = useState([]);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail);
  const athenaVirAuth = useSelector((state) => state.vir.athenaVirAuth);
  const selectedVirType = useSelector((state) => state.vir?.athenaSelectedType?.selectedType);
  const [photoURLs, setPhotoURLs] = useState([]);
  const photos = useSelector((state) => state.vir?.athenaVirDetail.data.PhotoBatch);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightBoxOpen, setLightBoxOpen] = useState(false);
  const navigate = useNavigate();
  const brand = getBrandFromUrl().toLowerCase();
  const dispatch = useDispatch();

  useEffect(() => {
    setDamageCodes(athenaVirDetail.data.DamageDetails?.DamageCodes);
    setPhotoURLs(
      photos
        .filter((photo) => photo.author === "staff")
        .map((photo) => {
          return photo.photoUrls;
        })
        .reduce((acc, curr) => acc.concat(curr), [])
        .map((obj) => {
          return obj.url;
        })
    );
  }, []);

  const continueForm = () => {
    if (selectedVirType === "panel") {
      navigate(`/vehicleincidents/vehicleconditionandpolice?brand=${brand}`, {
        replace: true,
      });
    } else if (
      selectedVirType === "windscreen" ||
      selectedVirType === "interior" ||
      selectedVirType === "mechanical"
    ) {
      navigate(`/vehicleincidents/incidentdetails?brand=${brand}`, { replace: true });
    }
  };

  const viewPhotos = () => {
    setLightBoxOpen(true);
    if (photoURLs.length === 0) {
      dispatch(
        appActions.createToast({
          type: "success",
          message: "No image is attached.",
        })
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          fontFamily: "Ride",
          color: "#333",
          margin: "0 auto",
        }}
      >
        <h2 className={classes.title}>Damage Notice</h2>
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          style={{ paddingTop: "10px" }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: "20px", maxWidth: "550px" }}
          >
            <WarningIcon color="primary" style={{ fontSize: "50px" }} />
            <Typography
              className={classes.descripe}
              variant="body1"
              style={{ marginLeft: "8px", textAlign: "center", fontWeight: 500 }}
            >
              {athenaVirAuth.data?.returnLocation &&
                athenaVirAuth.data?.returnDate &&
                `Damage has been identified on vehicle ${athenaVirDetail.data.Registration} that was
              returned to ${athenaVirAuth.data?.returnLocation} at ${athenaVirAuth.data?.returnDate}.`}
            </Typography>
          </Box>
        </Box>

        <br></br>
        <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />
        <br></br>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: "10px" }}
        >
          <Box
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: "20px", maxWidth: "550px" }}
          >
            <p className={classes["sms-text"]} style={{ marginBottom: "20px" }}>
              The below damage has been identified
            </p>
            {damageCodes &&
              damageCodes.map((item, index) => {
                return (
                  <p
                    className={classes["sms-damage-code"]}
                    style={{ marginBottom: "10px" }}
                    key={index}
                  >
                    {item.Description}
                  </p>
                );
              })}
            <p className={classes["sms-text"]} style={{ marginBottom: "20px", marginTop: "20px" }}>
              Please complete the following vehicle incident report to provide us details of what
              happened. You will have the opportunity to share details of other involved drivers, as
              well as upload your own photos.
            </p>

            <Button
              variant="contained"
              size="large"
              onClick={viewPhotos}
              style={{
                textTransform: "none",
                marginTop: "30px",
                fontFamily: "Ride",
                borderRadius: "25px",
                width: "280px",
              }}
            >
              View Damage Photos
            </Button>
            <Button
              onClick={continueForm}
              variant="contained"
              size="large"
              style={{
                textTransform: "none",
                marginTop: "30px",
                fontFamily: "Ride",
                borderRadius: "25px",
                width: "280px",
              }}
            >
              Continue Form
            </Button>

            {lightBoxOpen && photoURLs.length > 0 && (
              <Lightbox
                mainSrc={photoURLs[lightboxIndex]}
                nextSrc={photoURLs[(lightboxIndex + 1) % photoURLs.length]}
                prevSrc={photoURLs[(lightboxIndex + photoURLs.length - 1) % photoURLs.length]}
                onCloseRequest={() => setLightBoxOpen(false)}
                onMovePrevRequest={() =>
                  setLightboxIndex((lightboxIndex + photoURLs.length - 1) % photoURLs.length)
                }
                onMoveNextRequest={() => setLightboxIndex((lightboxIndex + 1) % photoURLs.length)}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SmsPage;
